export default __webpack_public_path__ + "static/media/maisons_laffitte.6ab365f0.jpg";